// frontend/src/App.jsx

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import TermsModal from './components/TermsModal';
import TermsPage from './pages/TermsPage';
// Pages
import PrivacyPage from './pages/PrivacyPage';
import Home from './pages/Home';
import Dashboard from './pages/dashboard/Dashboard';
import ProfilePage from './pages/ProfilePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import SupportPage from './pages/SupportPage'; // NOVA IMPORT

// Championships
import ChampionshipList from './pages/championships/ChampionshipList';
import ChampionshipForm from './pages/championships/ChampionshipForm';
import ChampionshipDetail from './pages/championships/ChampionshipDetail';
import Standings from './pages/championships/Standings';
import MatchDetails from './pages/championships/MatchDetails';
import Statistics from './pages/championships/Statistics';
import KnockoutBracket from './pages/championships/KnockoutBracket';
import ChampionshipMatchesTab from './pages/championships/ChampionshipMatchesTab';
import ChampionshipTeamsTab from './pages/championships/ChampionshipTeamsTab';
import TeamFormInChampionship from './pages/championships/TeamFormInChampionship';
import ChampionshipMediaTab from './pages/championships/ChampionshipMediaTab';
import RoundStats from './pages/championships/RoundStats';
import SponsorList from './pages/championships/SponsorList';
import SponsorForm from './pages/championships/SponsorForm';
import ChampionshipNews from './pages/championships/ChampionshipNews';
import ChampionshipManagers from './pages/championships/ChampionshipManagers';
import ChampionshipRegulations from './pages/championships/ChampionshipRegulations';
import SumulaGenerator from './pages/championships/SumulaGenerator';
import ManageGroups from './pages/championships/ManageGroups';

// Championship Players
import ChampionshipPlayerForm from './pages/championships/ChampionshipPlayerForm';

// Teams
import TeamList from './pages/teams/TeamList';
import TeamForm from './pages/teams/TeamForm';
import TeamDetail from './pages/teams/TeamDetail';
import TeamEdit from './pages/teams/TeamEdit';
import TeamRegistrationSheet from './pages/teams/TeamRegistrationSheet';

// Players
import PlayerList from './pages/players/PlayerList';
import PlayerForm from './pages/players/PlayerForm';
import PlayerFormTeam from './pages/players/PlayerFormTeam';
import PlayerDetail from './pages/players/PlayerDetail';
import PlayerIdCard from './pages/players/PlayerIdCard';

// Auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import RecuperarSenha from './pages/auth/RecuperarSenha';
import ResetarSenha from './pages/ResetarSenha'; // ✅ Nova rota de redefinição
import SocialLoginCallback from './pages/auth/SocialLoginCallback';
import NotFound from './pages/NotFound';

// Market
import MarketForm from './components/MarketForm';
import MarketList from './components/MarketList';
import MarketPlayerDetails from './components/MarketPlayerDetails';
import MarketEditForm from './components/MarketEditForm';

function App() {
  return (
    <BrowserRouter>
      <TermsModal />
      <Routes>
        {/* Rotas de Autenticação (Públicas) */}
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<SocialLoginCallback />} />
        <Route path="/register" element={<Register />} />
        <Route path="/recuperar-senha" element={<RecuperarSenha />} />
        <Route path="/resetar-senha/:token" element={<ResetarSenha />} /> {/* ✅ Nova rota */}
        <Route path="termos" element={<TermsPage />} />
        <Route path="/privacidade" element={<PrivacyPage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          {/* Dashboard Geral (Privado) */}
          <Route path="dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          
          {/* Admin Geral (Privado - Apenas Admin) */}
          <Route path="admin" element={
            <PrivateRoute roles={["Admin"]}>
              <AdminDashboard />
            </PrivateRoute>
          } />

          {/* Perfil do Usuário (Privado) */}
          <Route path="profile" element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          } />

          {/* NOVA ROTA DE SUPORTE */}
          <Route path="suporte" element={
            <PrivateRoute>
              <SupportPage />
            </PrivateRoute>
          } />

          {/* --- MERCADO DA BOLA --- */}
          <Route path="market">
            {/* PÚBLICO */}
            <Route index element={<MarketList />} />
            <Route path="details/:id" element={<MarketPlayerDetails />} />
            
            {/* PRIVADO */}
            <Route path="edit/:id" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <MarketEditForm />
              </PrivateRoute>
            } />
            <Route path="create" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <MarketForm />
              </PrivateRoute>
            } />
          </Route>

          {/* --- CAMPEONATOS --- */}
          <Route path="championships">
            {/* PÚBLICO: Lista Geral */}
            <Route index element={<ChampionshipList />} />
            
            {/* PRIVADO: Criar */}
            <Route path="new" element={
              <PrivateRoute roles={["Admin", "Gestor", "Diretor"]}>
                <ChampionshipForm />
              </PrivateRoute>
            } />

            {/* Detalhes do Campeonato (:id) */}
            <Route path=":id">
              {/* === ROTAS PÚBLICAS === */}
              <Route index element={<ChampionshipDetail />} />
              <Route path="standings" element={<Standings />} />
              <Route path="matches" element={<ChampionshipMatchesTab />} />
              <Route path="matches/:matchId" element={<MatchDetails />} />
              <Route path="statistics" element={<Statistics />} />
              <Route path="knockout" element={<KnockoutBracket />} />
              <Route path="teams" element={<ChampionshipTeamsTab />} />
              <Route path="media" element={<ChampionshipMediaTab />} />
              <Route path="highlights" element={<RoundStats />} />
              <Route path="sponsors" element={<SponsorList />} />
              <Route path="news" element={<ChampionshipNews />} />
              <Route path="regulations" element={<ChampionshipRegulations />} />
              <Route path="market" element={<MarketList />} />
              <Route path="managers" element={<ChampionshipManagers />} />

              {/* === ROTAS PRIVADAS (GESTÃO) === */}
              <Route path="edit" element={
                <PrivateRoute roles={["Admin", "Gestor", "Diretor"]}>
                  <ChampionshipForm />
                </PrivateRoute>
              } />
              <Route path="manage-groups" element={
                <PrivateRoute roles={["Admin", "Gestor", "Diretor"]}>
                  <ManageGroups />
                </PrivateRoute>
              } />
              <Route path="teams/register" element={
                <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                  <TeamFormInChampionship />
                </PrivateRoute>
              } />
              <Route path="sponsors/new" element={
                <PrivateRoute roles={["Admin", "Gestor", "Diretor"]}>
                  <SponsorForm />
                </PrivateRoute>
              } />
            </Route>
          </Route>

          {/* --- ROTA CORRIGIDA: Championship Player Edit (SEM BARRA NO INÍCIO) --- */}
          <Route 
            path="championship-player/:championshipPlayerId/edit" 
            element={
              <PrivateRoute roles={["Admin", "Gestor", "Diretor", "Técnico"]}>
                <ChampionshipPlayerForm />
              </PrivateRoute>
            } 
          />

          {/* --- TIMES --- */}
          <Route path="teams">
            {/* PÚBLICO: Lista */}
            <Route index element={<TeamList />} />
            
            {/* PÚBLICO: Detalhe */}
            <Route path=":id" element={<TeamDetail />} />
            
            {/* PRIVADO: Criar */}
            <Route path="new" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <TeamForm />
              </PrivateRoute>
            } />
            
            {/* PRIVADO: Editar */}
            <Route path=":id/edit" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <TeamEdit />
              </PrivateRoute>
            } />
            
            {/* PRIVADO: Ficha */}
            <Route path=":id/registration-sheet" element={
              <PrivateRoute>
                <TeamRegistrationSheet />
              </PrivateRoute>
            } />
            
            {/* PRIVADO: Adicionar Jogador */}
            <Route path=":teamId/players/new" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <PlayerFormTeam />
              </PrivateRoute>
            } />
          </Route>

          {/* --- JOGADORES --- */}
          <Route path="players">
            {/* PRIVADO: Lista */}
            <Route index element={
              <PrivateRoute>
                <PlayerList />
              </PrivateRoute>
            } />
            
            {/* PRIVADO: Criar */}
            <Route path="new" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <PlayerForm />
              </PrivateRoute>
            } />
            <Route path=":id/edit" element={
              <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
                <PlayerForm />
              </PrivateRoute>
            } />
            
            {/* PÚBLICO: Detalhe e Carteirinha */}
            <Route path=":playerId" element={<PlayerDetail />} />
            <Route path=":playerId/id-card" element={<PlayerIdCard />} />
          </Route>

          {/* --- SÚMULA (Privada) --- */}
          <Route path="partida/:matchId/sumula" element={
            <PrivateRoute roles={["Admin", "Gestor", "Técnico", "Diretor", "Jogador"]}>
              <SumulaGenerator />
            </PrivateRoute>
          } />

        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;